const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  label: yup.string().required("Label is required"),
  status: yup.string().required("Status is required"),
});

module.exports = {
  create,
};
